var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_434_2433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_434_2433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18C7.91667 18 8.27083 17.8542 8.5625 17.5625C8.85417 17.2708 9 16.9167 9 16.5C9 16.0833 8.85417 15.7292 8.5625 15.4375C8.27083 15.1458 7.91667 15 7.5 15C7.08333 15 6.72917 15.1458 6.4375 15.4375C6.14583 15.7292 6 16.0833 6 16.5C6 16.9167 6.14583 17.2708 6.4375 17.5625C6.72917 17.8542 7.08333 18 7.5 18ZM7.5 9C7.91667 9 8.27083 8.85417 8.5625 8.5625C8.85417 8.27083 9 7.91667 9 7.5C9 7.08333 8.85417 6.72917 8.5625 6.4375C8.27083 6.14583 7.91667 6 7.5 6C7.08333 6 6.72917 6.14583 6.4375 6.4375C6.14583 6.72917 6 7.08333 6 7.5C6 7.91667 6.14583 8.27083 6.4375 8.5625C6.72917 8.85417 7.08333 9 7.5 9ZM12 13.5C12.4167 13.5 12.7708 13.3542 13.0625 13.0625C13.3542 12.7708 13.5 12.4167 13.5 12C13.5 11.5833 13.3542 11.2292 13.0625 10.9375C12.7708 10.6458 12.4167 10.5 12 10.5C11.5833 10.5 11.2292 10.6458 10.9375 10.9375C10.6458 11.2292 10.5 11.5833 10.5 12C10.5 12.4167 10.6458 12.7708 10.9375 13.0625C11.2292 13.3542 11.5833 13.5 12 13.5ZM16.5 18C16.9167 18 17.2708 17.8542 17.5625 17.5625C17.8542 17.2708 18 16.9167 18 16.5C18 16.0833 17.8542 15.7292 17.5625 15.4375C17.2708 15.1458 16.9167 15 16.5 15C16.0833 15 15.7292 15.1458 15.4375 15.4375C15.1458 15.7292 15 16.0833 15 16.5C15 16.9167 15.1458 17.2708 15.4375 17.5625C15.7292 17.8542 16.0833 18 16.5 18ZM16.5 9C16.9167 9 17.2708 8.85417 17.5625 8.5625C17.8542 8.27083 18 7.91667 18 7.5C18 7.08333 17.8542 6.72917 17.5625 6.4375C17.2708 6.14583 16.9167 6 16.5 6C16.0833 6 15.7292 6.14583 15.4375 6.4375C15.1458 6.72917 15 7.08333 15 7.5C15 7.91667 15.1458 8.27083 15.4375 8.5625C15.7292 8.85417 16.0833 9 16.5 9ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/Car.db13dc25f2fe392ec9e54c18ccb0daab.svg";
export { ForwardRef as ReactComponent };